import { ChangeEvent, ChangeEventHandler, memo, useMemo } from 'react'
import { useField, UseFieldConfig } from 'react-final-form'
import { ITextAreaProps } from '@cargomart/ui'
import { checkFieldError, getFieldErrorMessage } from 'helpers/form'

import { OrderCreateComment } from '../components/OrderCreate/OrderCreateComment'

interface IProps
  extends Pick<UseFieldConfig<string>, 'format' | 'formatOnBlur' | 'validate'>,
    Omit<ITextAreaProps, 'value' | 'defaultValue'> {
  name: string
  onChange?: (value: ChangeEvent<HTMLTextAreaElement>) => void
}

export const FieldOrderCreateComment = memo<IProps>(function FieldOrderCreateComment({
  className,
  name,
  format,
  formatOnBlur,
  validate,
  onChange
}) {
  const { input, meta } = useField<string>(name, {
    validate,
    format,
    formatOnBlur,
    parse: (value?: string) => value || ''
  })

  const handleChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => {
    input.onChange(event?.target?.value)
    onChange && onChange(event?.target?.value as unknown as ChangeEvent<HTMLTextAreaElement>)
  }

  const error = useMemo(() => getFieldErrorMessage(checkFieldError(meta)), [meta])

  return (
    <div className={className}>
      <OrderCreateComment
        error={error}
        onBlur={input.onBlur}
        onChange={handleChange}
        onFocus={input.onFocus}
        value={input.value}
      />
    </div>
  )
})
